import Page from "webPage/Page";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";

Page.register('/contact', () => {
    handleContactForm($('.js-contact-form'));
    //Map Styling
    let styles = [
        {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
                {saturation: -100}, // <-- THIS
            ],
        }, {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
                {saturation: 0}, // <-- THIS
            ],
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {saturation: -100}, // <-- THIS
            ],
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
                {saturation: -100}, // <-- THIS
            ],
        }, {
            featureType: 'road', // set the road
            elementType: 'all',
            stylers: [
                {hue: '#6e7708'},
                {lightness: -40},
            ],
        },
    ];

    let myLatlng = new google.maps.LatLng(52.281734, -1.585945);
    let options = {
        mapTypeControlOptions: {
            mapTypeIds: ['Styled'],
        },
        zoom: 14,
        center: myLatlng,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        mapTypeId: 'Styled',
        draggable: true,
    };
    let div = document.getElementById('map');
    let map = new google.maps.Map(div, options);
    let styledMapType = new google.maps.StyledMapType(styles, {name: 'Styled'});
    map.mapTypes.set('Styled', styledMapType);

    let marker = new google.maps.Marker({
        position: myLatlng,
    });

    marker.setMap(map);
});

export function handleContactForm($element) {
    let validator = FormValidator.attach($element, {
        inputOptions: {operator: "your"},
    }).on("input:invalid", function (data) {
        data.input.$input.parents('.formrow').addClass('formrow--error');
    }).on("input:valid", function (data) {
        data.input.$input.parents('.formrow').removeClass('formrow--error');
    }).on("submit", ($form) => {
        let $btn = $form.find("button[type=submit]");
        if ($btn.is(".button--loading")) return;
        $btn.addClass("button--loading");

        $form.parents('.contact-form').removeClass('contact-form--error');
        Ajax.post("contact", "", $form.serializeJSON(), Ajax.WEBSITE).then(() => {
            $form.parents('.contact-form').addClass('contact-form--success');
        }).catch((e) => {
            console.log(e);
            validator.handleValidationException(e);
            $form.parents('.contact-form').addClass('contact-form--error');
            $btn.removeClass("button--loading");
        });
    });

}
